export default {
  namespaced: true,
  state: {
    tableLoading: false,
    showDataTable: false,
    filterParams: {},
    statusTypes: [
      {
        label: 'Visiteret haster',
        key: 1,
        color: 'color-monza',
      },
      {
        label: 'Klar til indkaldelse',
        key: 3,
        color: 'color-lima',
      },
      {
        label: 'Visiteret til GA',
        key: 14,
        color: 'color-portage',
      },
      {
        label: 'Visiteret til JT',
        key: 17,
        color: 'color-cornflower-blue',
      },
      {
        label: 'Indkaldt, afventer opring',
        key: 5,
        color: 'color-bilbao',
      },
      {
        label: 'Indkaldt 2 gang, afventer',
        key: 9,
        color: 'color-lavender',
      },
      {
        label: 'I behandling',
        key: 6,
        color: 'color-lochmara',
      },
      {
        label: 'I behandling, skal kontaktes for ny tid',
        key: 15,
        color: 'color-lochinvar',
      },
      {
        label: 'Afventer patienten ringer tilbage for tid',
        key: 12,
        color: 'color-shakespeare',
      },
      {
        label: 'Har forsøgt at kontakte via alle kanaler uden held',
        key: 11,
        color: 'color-froly',
      },
    ],
  },
  mutations: {
    updateTableLoading(state, payload) {
      state.tableLoading = payload;
    },
    updateShowDataTable(state, payload) {
      state.showDataTable = payload;
    },
    updateFilterParams(state, payload) {
      state.filterParams = payload;
    },
  },
};
